import { Component } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [TegelModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
  environment = environment.production;
  environmentName = (environment as any).environmentName || '';
}
